import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();
export default new Vuex.Store({
    state: {
        activeIndexAdminMenu: 1,
        userType: 0,
        permissionsCurrentUser: [],
        selectedAppId: '',
        portalNewsIdList: [],
        nbrbNewsIdList: [],
        selectedContactId: 0,
        currentUserUnreadMessageCount: 0,
        restoreSystem: false
    },
    mutations: {
        updateActiveIndexAdminMenu(state: any, newData: number) {
            state.activeIndexAdminMenu = newData;
        },
        updatePermissionsCurrentUser(state: any, newData: object) {
            state.permissionsCurrentUser = newData;
        },
        updateSelectedAppId(state: any, newData: string) {
            state.selectedAppId = newData;
        },
        updatePortalNewsIdList(state: any, newData: Array<number>) {
            state.portalNewsIdList = newData;
        },
        updateNBRBNewsIdList(state: any, newData: Array<number>) {
            state.nbrbNewsIdList = newData;
        },
        updateSelectedContactId(state: any, newData: number) {
            state.selectedContactId = newData;
        },
        updateCurrentUserUnreadMessageCount(state: any, newData: number) {
            state.currentUserUnreadMessageCount = newData;
        },
        updateRestoreSystem(state: any, newData: number) {
            state.restoreSystem = newData;
        },
        updateUserType(state: any, newData: number) {
            state.userType = newData;
        },
    }
});




// WEBPACK FOOTER //
// ./common/stores/appStore.ts